<div class="custom-page-column">
  <!-- Page 1 -->
  <div class="pdf-page font-small app-cp-00-30-10-12" id="cp301012">
    <p class="font-small text-end">
      <b>COMMERCIAL PROPERTY<br />
        CP 00 30 10 12</b>
    </p>

    <p class="font-large" style="text-align: center">
      <b>
        BUSINESS INCOME (AND EXTRA EXPENSE) <br />
        COVERAGE FORM
      </b>
    </p>

    <p>
      Various provisions in this policy restrict coverage. Read the entire
      policy carefully to determine rights, duties and what is and is not
      covered. <br />
      Throughout this policy, the words "you" and "your" refer to the Named
      Insured shown in the Declarations. The words "we", "us" and "our" refer to
      the company providing this insurance. <br />
      Other words and phrases that appear in quotation marks have special
      meaning. Refer to Section F. Definitions.
    </p>

    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ol type="A">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Coverage</b><br />
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>Business Income</b><br />
                    Business Income means the:<br />
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Net Income (Net Profit or Loss before income taxes) that
                          would have been earned or incurred; and
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Continuing normal operating expenses incurred, including
                          payroll.
                        </span>
                      </li>
                    </ol>
                    For manufacturing risks, Net Income includes the net sales value
                    of production.<br />
                    Coverage is provided as described and limited below for one or
                    more of the following options for which a Limit Of Insurance is
                    shown in the Declarations:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Business Income Including "Rental Value".</span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Business Income Other Than "Rental Value".</span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">"Rental Value"</span>
                      </li>
                    </ol>
                    If option <b>(1)</b> above is selected, the term Business Income
                    will include "Rental Value". If option <b>(3)</b> above is
                    selected, the term Business Income will mean "Rental Value"
                    only.<br />
                    If Limits of Insurance are shown under more than one of the
                    above options, the provisions of this Coverage Part apply
                    separately to each.<br />
                    We will pay for the actual loss of Business Income you sustain
                    due to the necessary "suspension" of your "operations" during
                    the "period of restoration". The "suspension" must be caused by
                    direct physical loss of or damage to property at premises which
                    are described in the Declarations and for which a Business
                    Income Limit Of Insurance is shown in the Declarations. The loss
                    or damage must be caused by or result from a Covered Cause of
                    Loss. With respect to loss of or damage to personal property in
                    the open or personal property in a vehicle, the described
                    premises include the area within 100 feet of such premises.
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ol start="2">
          With respect to the requirements set forth in the preceding paragraph,
          if you occupy only part of a building, your premises means:
          <ol class="list-parentheses type-lower-alpha">
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
                The portion of the building which you rent, lease or occupy;
              </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
                The area within 100 feet of the building or within 100 feet of the
                premises described in the Declarations, whichever distance is
                greater (with respect to loss of or damage to personal property in
                the open or personal property in a vehicle); and
              </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
                Any area within the building or at the described premises, if that
                area services, or is used to gain access to, the portion of the
                building which you rent, lease or occupy.
              </span>
            </li>
          </ol>

          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Extra Expense</b><br />
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Extra Expense Coverage is provided at the premises described in
                    the Declarations only if the Declarations show that Business
                    Income Coverage applies at that premises.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Extra Expense means necessary expenses you incur during the
                    "period of restoration" that you would not have incurred if
                    there had been no direct physical loss or damage to property
                    caused by or resulting from a Covered Cause of Loss. <br />
                    We will pay Extra Expense (other than the expense to repair or
                    replace property) to:
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          <b>(1).</b> Avoid or minimize the "suspension" of business
                          and to continue operations at the described premises or at
                          replacement premises or temporary locations, including
                          relocation expenses and costs to equip and operate the
                          replacement location or temporary location.
                        </span>
                      </li>
                    </ul>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
    </table>

  </div>

  <!-- Page 2 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(2)</b> Minimize the "suspension" of business if you cannot
                    continue "operations".
                  </span>
                </li>
              </ul>
              We will also pay Extra Expense to repair or replace property, but
              only to the extent it reduces the amount of loss that otherwise
              would have been payable under this Coverage Form.
            </span>
          </li>
        </ul>
        <ol start="3">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Covered Causes Of Loss, Exclusions And Limitations </b><br />
              See applicable Causes Of Loss form as shown in the Declarations.
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Additional Limitation – Interruption Of Computer Operations</b>
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Coverage for Business Income does not apply when a "suspension"
                    of "operations" is caused by destruction or corruption of
                    electronic data, or any loss or damage to electronic data,
                    except as provided under the Additional Coverage, Interruption
                    Of Computer Operations.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Coverage for Extra Expense does not apply when action is taken
                    to avoid or minimize a "suspension" of "operations" caused by
                    destruction or corruption of electronic data, or any loss or
                    damage to electronic data, except as provided under the
                    Additional Coverage, Interruption Of Computer Operations.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Electronic data means information, facts or computer programs
                    stored as or on, created or used on, or transmitted to or from
                    computer software (including systems and applications software),
                    on hard or floppy disks, CD-ROMs, tapes, drives, cells, data
                    processing devices or any other repositories of computer
                    software which are used with electronically controlled
                    equipment. The term computer programs, referred to in the
                    foregoing description of electronic data, means a set of related
                    electronic instructions which direct the operations and
                    functions of a computer or device connected to it, which enable
                    the computer or device to receive, process, store, retrieve or
                    send data.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    This Additional Limitation does not apply when loss or damage to
                    electronic data involves only electronic data which is
                    integrated in and operates or controls a building's elevator,
                    lighting, heating, ventilation, air conditioning or security
                    system.
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li class="list-type-none">
            <ol start="5">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Additional Coverages</b>
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        <b>Civil Authority</b><br />
                        In this Additional Coverage, Civil Authority, the described
                        premises are premises to which this Coverage Form applies,
                        as shown in the Declarations. <br />
                        When a Covered Cause of Loss causes damage to property other
                        than property at the described premises, we will pay for the
                        actual loss of Business Income you sustain and necessary
                        Extra Expense caused by action of civil authority that
                        prohibits access to the described premises, provided that
                        both of the following apply:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              Access to the area immediately surrounding the damaged
                              property is prohibited by civil authority as a result of
                              the damage, and the described premises are within that
                              area but are not more than one mile from the damaged
                              property; and
                            </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              The action of civil authority is taken in response to
                              dangerous physical conditions resulting from the damage
                              or continuation of the Covered Cause of Loss that caused
                              the damage, or the action is taken to enable a civil
                              authority to have unimpeded access to the damaged
                              property.
                            </span>
                          </li>
                        </ol>
                        Civil Authority Coverage for Business Income will begin 72
                        hours after the time of the first action of civil authority
                        that prohibits access to the described premises and will
                        apply for a period of up to four consecutive weeks from the
                        date on which such coverage began. <br />
                        Civil Authority Coverage for Extra Expense will begin
                        immediately after the time of the first action of civil
                        authority that prohibits access to the described premises
                        and will end:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              Four consecutive weeks after the date of that action; or
                            </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              When your Civil Authority Coverage for Business Income
                              ends;
                            </span>
                          </li>
                        </ol>
                        whichever is later.
                      </span>
                    </li>
                  </ol>
                </span>
              </li>
            </ol>
          </li>
        </ul>
      </td>
    </table>
  </div>

  <!-- Page 3 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li class="list-type-none">
            <ol start="2" type="a">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Alterations And New Buildings</b><br />
                  We will pay for the actual loss of Business Income you sustain
                  and necessary Extra Expense you incur due to direct physical
                  loss or damage at the described premises caused by or resulting
                  from any Covered Cause of Loss to:
                  <ol class="list-parentheses">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        New buildings or structures, whether complete or under
                        construction;
                      </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        Alterations or additions to existing buildings or
                        structures; and
                      </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        Machinery, equipment, supplies or building materials located
                        on or within 100 feet of the described premises and:
                        <ol class="list-parentheses type-lower-alpha">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              Used in the construction, alterations or additions; or
                            </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Incidental to the occupancy of new buildings.</span>
                          </li>
                        </ol>
                      </span>
                    </li>
                  </ol>
                  If such direct physical loss or damage delays the start of
                  "operations", the "period of restoration" for Business Income
                  Coverage will begin on the date "operations" would have begun if
                  the direct physical loss or damage had not occurred.
                </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Extended Business Income</b><br />
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        <b>(1) Business Income Other Than "Rental Value" </b><br />
                        If the necessary "suspension" of your "operations" produces
                        a Business Income loss payable under this policy, we will
                        pay for the actual loss of Business Income you incur during
                        the period that:
                        <ul style="list-style-type: none">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              <b>(a)</b> Begins on the date property (except "finished
                              stock") is actually repaired, rebuilt or replaced and
                              "operations" are resumed; and
                            </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              <b>(b)</b> Ends on the earlier of:
                              <ul style="list-style-type: none">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    <b>(i)</b> The date you could restore your
                                    "operations", with reasonable speed, to the level
                                    which would generate the business income amount that
                                    would have existed if no direct physical loss or
                                    damage had occurred; or
                                  </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    <b>(ii)</b> 60 consecutive days after the date
                                    determined in (1)(a) above.
                                  </span>
                                </li>
                              </ul>
                            </span>
                          </li>
                        </ul>
                      </span>
                    </li>
                  </ul>
                </span>
              </li>
            </ol>
          </li>
        </ul>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          However, Extended Business Income does not apply to loss of
                          Business Income incurred as a result of unfavorable business
                          conditions caused by the impact of the Covered Cause of Loss
                          in the area where the described premises are located. <br />
                          Loss of Business Income must be caused by direct physical
                          loss or damage at the described premises caused by or
                          resulting from any Covered Cause of Loss.
                        </span>
                      </li>
                    </ul>
                  </span>
                </li>
              </ul>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(2). "Rental Value"</b><br />
                    If the necessary "suspension" of your "operations" produces a
                    "Rental Value" loss payable under this policy, we will pay for
                    the actual loss of "Rental Value" you incur during the period
                    that:
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          <b>(a)</b> Begins on the date property is actually repaired,
                          rebuilt or replaced and tenantability is restored; and
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          <b>(b)</b> Ends on the earlier of: <br />
                          <ul style="list-style-type: none">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                <b>(i)</b> The date you could restore tenant occupancy,
                                with reasonable speed, to the level which would generate
                                the "Rental Value" that would have existed if no direct
                                physical loss or damage had occurred; or
                              </span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                <b>(ii)</b> 60 consecutive days after the date
                                determined in <b>(2)(a)</b> above.
                              </span>
                            </li>
                          </ul>
                        </span>
                      </li>
                    </ul>
                    However, Extended Business Income does not apply to loss of
                    "Rental Value" incurred as a result of unfavorable business
                    conditions caused by the impact of the Covered Cause of Loss in
                    the area where the described premises are located. <br />
                    Loss of "Rental Value" must be caused by direct physical loss or
                    damage at the described premises caused by or resulting from any
                    Covered Cause of Loss.
                  </span>
                </li>
              </ul>
            </span>
          </li>
        </ul>

        <ol type="a" start="4">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Interruption Of Computer Operations</b><br />
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(1).</b> Under this Additional Coverage, electronic data has
                    the meaning described under Additional Limitation – Interruption
                    Of Computer Operations.
                  </span>
                </li>
              </ul>
            </span>
          </li>
        </ol>
      </td>
    </table>
  </div>

  <!-- Page 4 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>(2)</b> Subject to all provisions of this Additional Coverage,
              you may extend the insurance that applies to Business Income and
              Extra Expense to apply to a "suspension" of "operations" caused by
              an interruption in computer operations due to destruction or
              corruption of electronic data due to a Covered Cause of Loss.
              However, we will not provide coverage under this Additional Coverage
              when the Additional Limitation – Interruption Of Computer Operations
              does not apply based on Paragraph <b>A.4.d.</b> therein.
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>(3)</b> With respect to the coverage provided under this
              Additional Coverage, the Covered Causes of Loss are subject to the
              following:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(a)</b> If the Causes Of Loss – Special Form applies,
                    coverage under this Additional Coverage, Interruption Of
                    Computer Operations, is limited to the "specified causes of
                    loss" as defined in that form and Collapse as set forth in that
                    form.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(b)</b> If the Causes Of Loss – Broad Form applies, coverage
                    under this Additional Coverage, Interruption Of Computer
                    Operations, includes Collapse as set forth in that form.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(c)</b> If the Causes Of Loss form is endorsed to add a
                    Covered Cause of Loss, the additional Covered Cause of Loss does
                    not apply to the coverage provided under this Additional
                    Coverage, Interruption Of Computer Operations.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(d)</b> The Covered Causes of Loss include a virus, harmful
                    code or similar instruction introduced into or enacted on a
                    computer system (including electronic data) or a network to
                    which it is connected, designed to damage or destroy any part of
                    the system or disrupt its normal operation. But there is no
                    coverage for an interruption related to manipulation of a
                    computer system (including electronic data) by any employee,
                    including a temporary or leased employee, or by an entity
                    retained by you or for you to inspect, design, install,
                    maintain, repair or replace that system.
                  </span>
                </li>
              </ul>
            </span>
          </li>
        </ul>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(4)</b> The most we will pay under this Additional Coverage,
                    Interruption Of Computer Operations, is $2,500 (unless a higher
                    limit is shown in the Declarations) for all loss sustained and
                    expense incurred in any one policy year, regardless of the
                    number of interruptions or the number of premises, locations or
                    computer systems involved. If loss payment relating to the first
                    interruption does not exhaust this amount, then the balance is
                    available for loss or expense sustained or incurred as a result
                    of subsequent interruptions in that policy year. A balance
                    remaining at the end of a policy year does not increase the
                    amount of insurance in the next policy year. With respect to any
                    interruption which begins in one policy year and continues or
                    results in additional loss or expense in a subsequent policy
                    year(s), all loss and expense is deemed to be sustained or
                    incurred in the policy year in which the interruption began.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(5)</b> This Additional Coverage, Interruption Of Computer
                    Operations, does not apply to loss sustained or expense incurred
                    after the end of the "period of restoration", even if the amount
                    of insurance stated in <b>(4)</b> above has not been exhausted.
                  </span>
                </li>
              </ul>
            </span>
          </li>
        </ul>
        <ol start="6">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Coverage Extension</b><br />
              If a Coinsurance percentage of 50% or more is shown in the
              Declarations, you may extend the insurance provided by this Coverage
              Part as follows: <br />
              <b>Newly Acquired Locations</b><br />
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    You may extend your Business Income and Extra Expense Coverages
                    to apply to property at any location you acquire other than
                    fairs or exhibitions.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The most we will pay under this Extension, for the sum of
                    Business Income loss and Extra Expense incurred, is $100,000 at
                    each location, unless a higher limit is shown in the
                    Declarations.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Insurance under this Extension for each newly acquired location
                    will end when any of the following first occurs:
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;"><b>(1)</b> This policy expires;</span>
                      </li>
                    </ul>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
    </table>
  </div>

  <!-- Page 5 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>(2)</b> 30 days expire after you acquire or begin to
                    construct the property; or
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;"><b>(3)</b> You report values to us.< </span>
                </li>
                We will charge you additional premium for values reported from the
                date you acquire the property.
              </ul>
              The Additional Condition, Coinsurance, does not apply to this
              Extension.
            </span>
          </li>
        </ul>
        <ol type="A" start="2">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Limits Of Insurance</b><br />
              The most we will pay for loss in any one occurrence is the
              applicable Limit Of Insurance shown in the Declarations. <br />
              Payments under the following coverages will not increase the
              applicable Limit of Insurance:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">Alterations And New Buildings;< </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">. Civil Authority;< </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">Extra Expense; or< </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">Extended Business Income.< </span>
                </li>
              </ol>
              The amounts of insurance stated in the Interruption Of Computer
              Operations Additional Coverage and the Newly Acquired Locations
              Coverage Extension apply in accordance with the terms of those
              coverages and are separate from the Limit(s) Of Insurance shown in
              the Declarations for any other coverage.
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Loss Conditions</b><br />
              The following conditions apply in addition to the Common Policy
              Conditions and the Commercial Property Conditions:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>Appraisal </b><br />
                    If we and you disagree on the amount of Net Income and operating
                    expense or the amount of loss, either may make written demand
                    for an appraisal of the loss. In this event, each party will
                    select a competent and impartial appraiser. <br />
                    The two appraisers will select an umpire. If they cannot agree,
                    either may request that selection be made by a judge of a court
                    having jurisdiction. The appraisers will state separately the
                    amount of Net Income and operating expense or amount of loss. If
                    they fail to agree, they will submit their differences to the
                    umpire. A decision agreed to by any two will be binding. Each
                    party will:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Pay its chosen appraiser; and< </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          . Bear the other expenses of the appraisal and umpire
                          equally.
                        </span>
                      </li>
                    </ol>
                    If there is an appraisal, we will still retain our right to deny
                    the claim.
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ol start="2">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Duties In The Event Of Loss </b>
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    You must see that the following are done in the event of loss:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Notify the police if a law may have been broken.< </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Give us prompt notice of the direct physical loss or damage.
                          Include a description of the property involved.
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          As soon as possible, give us a description of how, when and
                          where the direct physical loss or damage occurred.
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Take all reasonable steps to protect the Covered Property
                          from further damage, and keep a record of your expenses
                          necessary to protect the Covered Property, for consideration
                          in the settlement of the claim. This will not increase the
                          Limit of Insurance. However, we will not pay for any
                          subsequent loss or damage resulting from a cause of loss
                          that is not a Covered Cause of Loss. Also, if feasible, set
                          the damaged property aside and in the best possible order
                          for examination.
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          As often as may be reasonably required, permit us to inspect
                          the property proving the loss or damage and examine your
                          books and records. Also permit us to take samples of damaged
                          and undamaged property for inspection, testing and analysis,
                          and permit us to make copies from your books and records.
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Send us a signed, sworn proof of loss containing the
                          information we request to investigate the claim. You must do
                          this within 60 days after our request. We will supply you
                          with the necessary forms.
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Cooperate with us in the investigation or settlement of the
                          claim.
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          If you intend to continue your business, you must resume all
                          or part of your "operations" as quickly as possible.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    We may examine any insured under oath, while not in the presence
                    of any other insured and at such times as may be reasonably
                    required, about any matter relating to this insurance or the
                    claim, including an insured's books and records. In the event of
                    an examination, an insured's answers must be signed.
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
    </table>
  </div>

  <!-- Page 6 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ol start="3">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Loss Determination </b><br />
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The amount of Business Income loss will be determined based on:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The Net Income of the business before the direct physical
                          loss or damage occurred;
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The likely Net Income of the business if no physical loss or
                          damage had occurred, but not including any Net Income that
                          would likely have been earned as a result of an increase in
                          the volume of business due to favorable business conditions
                          caused by the impact of the Covered Cause of Loss on
                          customers or on other businesses;
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The operating expenses, including payroll expenses,
                          necessary to resume "operations" with the same quality of
                          service that existed just before the direct physical loss or
                          damage; and
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Other relevant sources of information, including:
                          <ol class="list-parentheses type-lower-alpha">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">Your financial records and accounting
                                procedures;</span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">Bills, invoices and other vouchers; and</span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">Deeds, liens or contracts.</span>
                            </li>
                          </ol>
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The amount of Extra Expense will be determined based on:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          All expenses that exceed the normal operating expenses that
                          would have been incurred by "operations" during the "period
                          of restoration" if no direct physical loss or damage had
                          occurred. We will deduct from the total of such expenses:
                          <ol class="list-parentheses type-lower-alpha">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                The salvage value that remains of any property bought
                                for temporary use during the "period of restoration",
                                once "operations" are resumed; and
                              </span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                Any Extra Expense that is paid for by other insurance,
                                except for insurance that is written subject to the same
                                plan, terms, conditions and provisions as this
                                insurance; and
                              </span>
                            </li>
                          </ol>
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Necessary expenses that reduce the Business Income loss that
                          otherwise would have been incurred.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <ol type="a" start="3">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          <b>Resumption Of Operations</b> <br />
                          We will reduce the amount of your:
                          <ol class="list-parentheses">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                Business Income loss, other than Extra Expense, to the
                                extent you can resume your "operations", in whole or in
                                part, by using damaged or undamaged property (including
                                merchandise or stock) at the described premises or
                                elsewhere.
                              </span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                Extra Expense loss to the extent you can return
                                "operations" to normal and discontinue such Extra
                                Expense.
                              </span>
                            </li>
                          </ol>
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          If you do not resume "operations", or do not resume
                          "operations" as quickly as possible, we will pay based on
                          the length of time it would have taken to resume
                          "operations" as quickly as possible.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <b>Loss Payment </b> <br />
                    We will pay for covered loss within 30 days after we receive the
                    sworn proof of loss, if you have complied with all of the terms
                    of this Coverage Part, and:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          We have reached agreement with you on the amount of loss; or
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">An appraisal award has been made.</span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ul>
            </span>
          </li>
        </ul>
        <ol type="A" start="4">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Additional Condition</b>
              <br />
              <b>COINSURANCE</b>
              <br />
              If a Coinsurance percentage is shown in the Declarations, the
              following condition applies in addition to the Common Policy
              Conditions and the Commercial Property Conditions. <br />
              We will not pay the full amount of any Business Income loss if the
              Limit of Insurance for Business Income is less than:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The Coinsurance percentage shown for Business Income in the
                    Declarations; times
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The sum of: <br />
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The Net Income (Net Profit or Loss before income taxes), and
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Operating expenses, including payroll expenses,</span>
                      </li>
                    </ol>
                    that would have been earned or incurred (had no loss occurred)
                    by your "operations" at the described premises for the 12 months
                    following the inception, or last previous anniversary date, of
                    this policy (whichever is later).
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
    </table>
  </div>

  <!-- Page 7 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        Instead, we will determine the most we will pay using the following
        steps: <br />

        <table>
          <tbody>
            <tr>
              <td style="width: 25%">Step (1):</td>
              <td>
                Multiply the Net Income and operating expense for the 12 months
                following the inception, or last previous anniversary date, of
                this policy by the Coinsurance percentage;
              </td>
            </tr>
            <tr>
              <td>Step (2):</td>
              <td>
                Divide the Limit of Insurance for the described premises by the
                figure determined in Step <b>(1);</b> and
              </td>
            </tr>
            <tr>
              <td>Step (3):</td>
              <td>
                Multiply the total amount of loss by the figure determined in
                Step <b>(2)</b>.
              </td>
            </tr>
          </tbody>
        </table>
        We will pay the amount determined in Step <b>(3)</b> or the limit of
        insurance, whichever is less. For the remainder, you will either have to
        rely on other insurance or absorb the loss yourself. <br />
        In determining operating expenses for the purpose of applying the
        Coinsurance condition, the following expenses, if applicable, shall be
        deducted from the total of all operating expenses:
        <ol class="list-parentheses">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">Prepaid freight – outgoing;</span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">Returns and allowances;</span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">Discounts;</span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">Bad debts;</span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">Collection expenses;</span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              Cost of raw stock and factory supplies consumed (including
              transportation charges);
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">Cost of merchandise sold (including transportation charges);</span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              Cost of other supplies consumed (including transportation charges);
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              Cost of services purchased from outsiders (not employees) to resell,
              that do not continue under contract;
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              Power, heat and refrigeration expenses that do not continue under
              contract (if Form <b>CP 15 11</b> is attached);
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              All payroll expenses or the amount of payroll expense excluded (if
              Form <b>CP 15 10 </b>is attached); and
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              Special deductions for mining properties (royalties unless
              specifically included in coverage; actual depletion commonly known
              as unit or cost depletion – not percentage depletion; welfare and
              retirement fund charges based on tonnage; hired trucks).
            </span>
          </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <b>Example 1 (Underinsurance)</b> <br />
        <table>
          <tbody>
            <tr>
              <td style="width: 25%">When:</td>
              <td style="width: 50%">
                The Net Income and operating expenses for the 12 months
                following the inception, or last previous anniversary date, of
                this policy at the described premises would have been:
              </td>
              <td class="align-bottom text-end" style="width: 25%">
                $ 400,000
              </td>
            </tr>
            <tr>
              <td></td>
              <td>The Coinsurance percentage is:</td>
              <td class="text-end align-bottom">50%</td>
            </tr>
            <tr>
              <td></td>
              <td>The Limit of Insurance is:</td>
              <td class="align-bottom text-end">$ 150,000</td>
            </tr>
            <tr>
              <td></td>
              <td>The amount of loss is:</td>
              <td class="align-bottom text-end">$ 80,000</td>
            </tr>
            <tr>
              <td>Step (1):</td>
              <td>
                $400,000 x 50% = $200,000 <br />
                (the minimum amount of insurance to meet your Coinsurance
                requirements)
              </td>
              <td></td>
            </tr>
            <tr>
              <td>Step (2):</td>
              <td>$150,000 ÷ $200,000 = .75</td>
              <td></td>
            </tr>
            <tr>
              <td>Step (3):</td>
              <td>$80,000 x .75 = $60,000</td>
              <td></td>
            </tr>
          </tbody>
        </table>
        We will pay no more than $60,000. The remaining $20,000 is not covered.
        <br />
        <b>Example 2 (Adequate Insurance)</b><br />
        <table style="width: 100%">
          <tbody>
            <tr>
              <td>When:</td>
              <td>
                The Net Income and operating expenses for the 12 months
                following the inception, or last previous anniversary date, of
                this policy at the described premises would have been:
              </td>
              <td class="text-end align-bottom" style="width: 25%">
                $ 400,000
              </td>
            </tr>
            <tr>
              <td></td>
              <td>The Coinsurance percentage is:</td>
              <td class="text-end align-bottom">50%</td>
            </tr>
            <tr>
              <td></td>
              <td>The Limit of Insurance is:</td>
              <td class="text-end align-bottom">$ 200,000</td>
            </tr>
            <tr>
              <td></td>
              <td>The amount of loss is:</td>
              <td class="text-end align-bottom">$ 80,000</td>
            </tr>
          </tbody>
        </table>
        The minimum amount of insurance to meet your Coinsurance requirement is
        $200,000 ($400,000 x 50%). Therefore, the Limit of Insurance in this
        example is adequate and no penalty applies. We will pay no more than
        $80,000 (amount of loss). <br />
        This condition does not apply to Extra Expense Coverage<br />
        <b>E. Optional Coverages</b> <br />
        <div class="ps-2">
          If shown as applicable in the Declarations, the following Optional
          Coverages apply separately to each item.
          <ol>
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
                <b>Maximum Period Of Indemnity </b><br />
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                    <span style="font-weight: normal;">
                      The Additional Condition, Coinsurance, does not apply to this
                      Coverage Form at the described premises to which this Optional
                      Coverage applies.
                    </span>
                  </li>
                </ol>
              </span>
            </li>
          </ol>
        </div>
      </td>
    </table>
  </div>

  <!-- Page 8 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ol type="a" start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The most we will pay for the total of Business Income loss and
                    Extra Expense is the lesser of:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The amount of loss sustained and expenses incurred during
                          the 120 days immediately following the beginning of the
                          "period of restoration"; or
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">The Limit Of Insurance shown in the Declarations.</span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ul>
        <ol start="2">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Monthly Limit Of Indemnity </b><br />
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The Additional Condition, Coinsurance, does not apply to this
                    Coverage Form at the described premises to which this Optional
                    Coverage applies.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    . The most we will pay for loss of Business Income in each
                    period of 30 consecutive days after the beginning of the "period
                    of restoration" is:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">The Limit of Insurance, multiplied by</span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The fraction shown in the Declarations for this Optional
                          Coverage.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>

        <b>Example</b> <br />
        <table style="width: 100%">
          <tbody>
            <tr>
              <td>When:</td>
              <td>The Limit of Insurance is:</td>
              <td class="text-end align-bottom" style="width: 25%">
                $ 120,000
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                The fraction shown in the Declarations for this Optional
                Coverage is:
              </td>
              <td class="text-end align-bottom">1/4</td>
            </tr>
            <tr>
              <td></td>
              <td>
                The most we will pay for loss in each period of 30 consecutive
                days is:
              </td>
              <td class="text-end align-bottom">$ 30,000</td>
            </tr>
            <tr>
              <td></td>
              <td>
                ($120,000 x 1/4 = $30,000) If, in this example, the actual
                amount of loss is:
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Days 1–30:</td>
              <td class="text-end align-bottom">$ 40,000</td>
            </tr>
            <tr>
              <td></td>
              <td>Days 31–60:</td>
              <td class="text-end align-bottom">$ 20,000</td>
            </tr>
            <tr>
              <td></td>
              <td>Days 61–90:</td>
              <td class="text-end border-bottom-1 align-bottom">$ 30,000</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="text-end align-bottom">$ 90,000</td>
            </tr>
            <tr>
              <td></td>
              <td>Days 1–30:</td>
              <td class="text-end align-bottom">$ 30,000</td>
            </tr>
            <tr>
              <td></td>
              <td>Days 31–60:</td>
              <td class="text-end align-bottom">$ 20,000</td>
            </tr>
            <tr>
              <td></td>
              <td>Days 61–90:</td>
              <td class="text-end align-bottom border-bottom-1">$ 30,000</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="text-end align-bottom">$ 80,000</td>
            </tr>
            <tr>
              <td></td>
              <td colspan="2">The remaining $10,000 is not covered.</td>
            </tr>
          </tbody>
        </table>

        <ol start="3">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Business Income Agreed Value </b><br />
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    To activate this Optional Coverage:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          A Business Income Report/Work Sheet must be submitted to us
                          and must show financial data for your "operations":
                          <ol class="list-parentheses type-lower-alpha">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                During the 12 months prior to the date of the Work
                                Sheet; and
                              </span>
                            </li>
                          </ol>
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          <b>b.</b> Estimated for the 12 months immediately following
                          the inception of this Optional Coverage.
                        </span>
                      </li>
                    </ul>
                  </span>
                </li>
              </ul>
              <ol start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    The Declarations must indicate that the Business Income Agreed
                    Value Optional Coverage applies, and an Agreed Value must be
                    shown in the Declarations. The Agreed Value should be at least
                    equal to:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The Coinsurance percentage shown in the Declarations;
                          multiplied by
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The amount of Net Income and operating expenses for the
                          following 12 months you report on the Work Sheet.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ul>
        <ol type="a" start="2">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              The Additional Condition, Coinsurance, is suspended until:
              <ol class="list-parentheses">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    12 months after the effective date of this Optional Coverage; or
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">The expiration date of this policy;</span>
                </li>
                whichever occurs first.
              </ol>
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              We will reinstate the Additional Condition, Coinsurance,
              automatically if you do not submit a new Work Sheet and Agreed
              Value:
              <ol class="list-parentheses">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Within 12 months of the effective date of this Optional
                    Coverage; or
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    When you request a change in your Business Income Limit of
                    Insurance.
                  </span>
                </li>
              </ol>
            </span>
          </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              If the Business Income Limit of Insurance is less than the Agreed
              Value, we will not pay more of any loss than the amount of loss
              multiplied by:
              <ol class="list-parentheses">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">The Business Income Limit of Insurance; divided by</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">The Agreed Value.</span>
                </li>
              </ol>
            </span>
          </li>
        </ol>

        <b>Example</b><br />
        <table style="width: 100%">
          <tbody>
            <tr>
              <td>When:</td>
              <td>The Limit of Insurance is:</td>
              <td class="text-end" style="width: 25%">$ 100,000</td>
            </tr>
            <tr>
              <td></td>
              <td>The Agreed Value is:</td>
              <td class="text-end">$ 200,000</td>
            </tr>
            <tr>
              <td></td>
              <td>The amount of loss is:</td>
              <td class="text-end">$ 80,000</td>
            </tr>
            <tr>
              <td>Step (1):</td>
              <td>$100,000 ÷ $200,000 = .50</td>
              <td class="text-end"></td>
            </tr>
            <tr>
              <td>Step (2):</td>
              <td>50 x $80,000 = $40,000</td>
              <td></td>
            </tr>
          </tbody>
        </table>
        We will pay $40,000. The remaining $40,000 is not covered. <br />
        <ol start="4">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Extended Period Of Indemnity</b><br />
              Under Paragraph <b>A.5.c., Extended Business Income</b>, the number
              60 in Subparagraphs <b>(1)(b)</b> and <b>(2)(b)</b> is replaced by
              the number shown in the Declarations for this Optional Coverage.
            </span>
          </li>
        </ol>
      </td>
    </table>
  </div>

  <!-- Page 9 -->
  <div class="pdf-page font-small app-cp-00-30-10-12">
    <table style="width: 100%">
      <td style="width: 50%; vertical-align: top">
        <ol start="6" type="A">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <b>Definitions</b><br />
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    "Finished stock" means stock you have manufactured. <br />
                    "Finished stock" also includes whiskey and alcoholic products
                    being aged, unless there is a Coinsurance percentage shown for
                    Business Income in the Declarations. <br />
                    "Finished stock" does not include stock you have manufactured
                    that is held for sale on the premises of any retail outlet
                    insured under this Coverage Part.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    "Operations" means:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Your business activities occurring at the described
                          premises; and
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The tenantability of the described premises, if coverage for
                          Business Income Including "Rental Value" or "Rental Value"
                          applies.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    "Period of restoration" means the period of time that:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Begins: <br />
                          <ol class="list-parentheses">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                72 hours after the time of direct physical loss or
                                damage for Business Income Coverage; or
                              </span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                Immediately after the time of direct physical loss or
                                damage for Extra Expense Coverage;
                              </span>
                            </li>
                          </ol>
                          caused by or resulting from any Covered Cause of Loss at the
                          described premises; and
                        </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          Ends on the earlier of:
                          <ol class="list-parentheses">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                The date when the property at the described premises
                                should be repaired, rebuilt or replaced with reasonable
                                speed and similar quality; or
                              </span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                              <span style="font-weight: normal;">
                                The date when business is resumed at a new permanent
                                location.
                              </span>
                            </li>
                          </ol>
                        </span>
                      </li>
                      <p>
                        "Period of restoration" does not include any increased
                        period required due to the enforcement of or compliance with
                        any ordinance or law that:
                      </p>
                      <ol>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                          <span style="font-weight: normal;">
                            Regulates the construction, use or repair, or requires the
                            tearing down, of any property; or
                          </span>
                        </li>
                      </ol>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
            </li>
        </ol>
      </td>
      <td style="width: 50%; vertical-align: top">
        <ul style="list-style-type: none">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              <ol start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Requires any insured or others to test for, monitor, clean up,
                    remove, contain, treat, detoxify or neutralize, or in any way
                    respond to, or assess the effects of "pollutants".
                  </span>
                </li>
              </ol>
              The expiration date of this policy will not cut short the "period of
              restoration".
            </span>
            < </li>
        </ul>
        <ol start="4">
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              "Pollutants" means any solid, liquid, gaseous or thermal irritant or
              contaminant, including smoke, vapor, soot, fumes, acids, alkalis,
              chemicals and waste. Waste includes materials to be recycled,
              reconditioned or reclaimed.
            </span>
            < </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              "Rental Value" means Business Income that consists of:
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Net Income (Net Profit or Loss before income taxes) that would
                    have been earned or incurred as rental income from tenant
                    occupancy of the premises described in the Declarations as
                    furnished and equipped by you, including fair rental value of
                    any portion of the described premises which is occupied by you;
                    and
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    Continuing normal operating expenses incurred in connection with
                    that premises, including:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Payroll; and</span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                          The amount of charges which are the legal obligation of the
                          tenant(s) but would otherwise be your obligations.
                        </span>
                      </li>
                    </ol>
                  </span>
                </li>
              </ol>
            </span>
            < </li>
          <li style="padding-bottom: 10px; font-weight: bold;">
            <span style="font-weight: normal;">
              "Suspension" means:
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">The slowdown or cessation of your business activities; or</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                    That a part or all of the described premises is rendered
                    untenantable, if coverage for Business Income Including "Rental
                    Value" or "Rental Value" applies.
                  </span>
                </li>
              </ol>
            </span>
          </li>
        </ol>
      </td>
    </table>
  </div>
</div>